import { TM } from "@litres-libs/tracker-manager";

import { getConfig } from "lib/get-config";
import { useTranslation } from "lib/i18n/use-translation";
import { getBuyUrl } from "lib/urls/buy";

import { Bookmark } from "./bookmark";
import { Bookmarks } from "./bookmarks";
import { Fullscreen } from "./fullscreen";
import css from "./header.module.scss";
import { Help } from "./help";
import { Settings } from "./settings";
import { Title } from "./title";
import { Toc } from "./toc";

export function Header() {
  const { t } = useTranslation();
  const { trials, texttrialbutton, art } = getConfig();
  const isFragment = trials === 1;

  const handleBuyClick = () => {
    TM.sendEventSync({
      eventType: "fragment_click_buy",
      params: {
        id: art,
        source_internal: "fragment",
      },
    });

    window.location.href = getBuyUrl();
  };

  return (
    <div className={css.root}>
      <div className={css.title}>
        <Title />
      </div>
      <div className={css.settings}>
        {isFragment && (
          <button
            type="button"
            className={css.buyButton}
            onClick={handleBuyClick}
          >
            {texttrialbutton || t("Купить")}
          </button>
        )}
        <div className={css.help}>
          <Help />
        </div>
        <Toc />
        <div className={css.fullSettings}>
          <Bookmarks />
          <Settings />
          <Bookmark />
        </div>
        <Fullscreen />
      </div>
    </div>
  );
}
